import {
    OFFICE_PRODUCT_3D_OPEN,
    OFFICE_PRODUCT_3D_CLOSE,
} from "../actions/officeProduct3D.actions";

const initialState = {
    open: false,
    officeId: "",
    productId: "",
    title: "",
    source: "",
    product: null,
    openedAt: null,
};

export default function officeProduct3DReducer(state = initialState, action) {
    switch (action.type) {
        case OFFICE_PRODUCT_3D_OPEN:
            return {
                ...initialState,
                ...(action.payload || {}),
                open: true,
            };

        case OFFICE_PRODUCT_3D_CLOSE:
            return initialState;

        default:
            return state;
    }
}
